import { calculatePublicPath } from "canopy-sofe-extensions";

if (typeof __webpack_public_path__ !== "undefined") {
  __webpack_public_path__ = calculatePublicPath("notifications-ui");
}
